// Nav hides on scroll down, reappears on scroll up (standard pattern) —
// per explicit request, replacing the earlier footer-only hide behavior.
// Direction is tracked with hysteresis (FLIP_THRESHOLD_PX of accumulated
// scroll in one direction before flipping), not a raw per-event delta:
// Lenis fires many small "scroll" events per frame during a smooth
// scroll, so a naive tiny-delta check would flicker on momentum noise.
// Also always shown near the very top (SHOW_NEAR_TOP_PX) regardless of
// direction, so it doesn't hide itself away on a small scroll right at
// page load — EXCEPT during the homepage intro below, which deliberately
// overrides that.
//
// Still forced-hidden for the page's entire final stretch — from the
// instant the CTA band starts entering the viewport through the footer
// directory below it — regardless of scroll direction there, same reason
// as before: mix-blend-mode:difference reads as visual noise sitting
// over the CTA's own dark background if nav pops back up mid-footer.
// One observer on <footer> as a whole, not just .cta-band: .cta-band is
// only 100vh and the footer directory below it is taller, so by the time
// the user has scrolled into the directory rows the CTA band itself has
// scrolled fully out of view and would stop "intersecting" — observing
// the whole <footer> keeps nav hidden for that entire scroll instead of
// it popping back mid-footer.
//
// Homepage-only "hide until first scroll-up" intro (2026-08-21, per
// explicit request, "will make the intro more stand out"): nav starts
// hidden even at the very top instead of the usual always-show-near-top
// rule, and only reveals the first time the user scrolls up by
// FLIP_THRESHOLD_PX from whatever their deepest scroll point was — i.e.
// their first real upward gesture, not just any wiggle. Once that
// happens intro mode ends permanently for the page view and nav behaves
// exactly like every other page from then on. The actual initial hide
// happens inline in index.html itself (before this script — which sits
// after several render-blocking CDN loads — even runs), so there's no
// flash of visible nav first; this file's own init below just mirrors
// that same starting state into its `hidden` variable so the two stay in
// sync. Skipped under reduced-motion (matches the inline script's own
// guard) — nav is never gated behind a gesture for those users.
(function () {
  const nav = document.querySelector("nav");
  const footer = document.querySelector("footer");
  if (!nav) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isHomepage = location.pathname === "/" || location.pathname === "/index.html";

  const SHOW_NEAR_TOP_PX = 40;
  const FLIP_THRESHOLD_PX = 64;

  let introPending = isHomepage && !reducedMotion;
  let anchorY = window.scrollY;
  let inFooter = false;
  let hidden = introPending;

  if (hidden) nav.classList.add("nav-hidden");

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    nav.classList.toggle("nav-hidden", hidden);
  }

  function onScroll() {
    const y = window.scrollY;
    if (inFooter) {
      anchorY = y;
      return;
    }

    if (introPending) {
      const delta = y - anchorY;
      if (delta < -FLIP_THRESHOLD_PX) {
        introPending = false;
        setHidden(false);
        anchorY = y;
      } else if (delta > 0) {
        // Track the deepest point reached so far, so the eventual
        // scroll-up is measured from the real turnaround, not load y=0.
        anchorY = y;
      }
      return;
    }

    if (y <= SHOW_NEAR_TOP_PX) {
      setHidden(false);
      anchorY = y;
      return;
    }
    const delta = y - anchorY;
    if (delta > FLIP_THRESHOLD_PX) {
      setHidden(true);
      anchorY = y;
    } else if (delta < -FLIP_THRESHOLD_PX) {
      setHidden(false);
      anchorY = y;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });

  if (footer) {
    const io = new IntersectionObserver(
      ([entry]) => {
        inFooter = entry.isIntersecting;
        if (inFooter) setHidden(true);
        anchorY = window.scrollY;
      },
      { threshold: 0 }
    );
    io.observe(footer);
  }
})();
